export const createUpdateId = (): string => {
	const input = new Uint32Array(12);

	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!#$%^&-_0123456789';

	if (typeof window !== 'undefined' && window?.crypto) {
		const output = window.crypto.getRandomValues(input);

		return output.reduce(
			(acc, value) => `${acc}${characters.charAt(Math.floor(value % characters.length))}`,
			'',
		);
	}

	return input.reduce(
		(acc) => `${acc}${characters.charAt(Math.floor(Math.random() * characters.length))}`,
		'',
	);
};
